module.exports = __webpack_public_path__ + "img/customer_rh.72db43c4.jpeg";